export const REEL_TYPE_OPTIONS = [
  {
    id: "product",
    label: "Product Reel",
    enabled: true,
    description:
      "Spotlight one catalog product with lifestyle, on-screen captions, and AI voiceover. Best for direct product posts."
  },
  {
    id: "product-education",
    label: "Product + Education",
    enabled: false,
    description:
      "Teach a wellness or lifestyle tip, then introduce your product as part of the routine."
  },
  {
    id: "education",
    label: "Tips & Education",
    enabled: false,
    description:
      "Share helpful tips without pushing a specific product. Good for trust-building."
  },
  {
    id: "business",
    label: "Business Opportunity",
    enabled: true,
    description:
      "Share a brief invitation with an AI video — no income guarantees."
  },
  {
    id: "lifestyle",
    label: "Lifestyle",
    enabled: false,
    description:
      "Habit- or day-in-the-life reel with optional soft product mention."
  }
];

export function getReelTypeOption(id) {
  const normalized = String(id || "").trim();
  return REEL_TYPE_OPTIONS.find((option) => option.id === normalized)
    || REEL_TYPE_OPTIONS[0];
}
